<template>
  <div>
    <b-toast
      id="example-toast"
      toaster="b-toaster-bottom-right mb-5"
      :variant="alertOptions.variant"
      no-close-button
      solid
      :auto-hide-delay="alertOptions.delay"
    >
      <i class=" icon-info-circled" /> {{ alertOptions.message }}
    </b-toast>
  </div>
</template>

<script>
// @vuese
// Componente que muestra los mensajes de alertas
export default {
  name: 'Alerts',

  // @vuese
  props: {
    alertOptions: {
      type: Object,
      default: null,
    },
  },

  mounted() {
    this.$bvToast.show('example-toast');
  },

};
</script>

<style scoped>
</style>
